(() => {
  const drawerSelector = "[data-cart-drawer]";
  let returnFocus = null;
  let refreshController = null;

  const drawer = () => document.querySelector(drawerSelector);
  const rootPath = () => String(window.DORIMM_I18N?.root || "/").replace(/\/$/, "");
  const cartPath = () => `${rootPath()}/cart` || "/cart";
  const focusable = (root) => [...root.querySelectorAll("a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex='-1'])")]
    .filter((node) => !node.hidden && node.getAttribute("aria-hidden") !== "true");

  const updateBagCount = (root) => {
    const count = Number(root?.dataset.itemCount || 0);
    const label = root?.dataset.cartLabel || "Cart";
    document.querySelectorAll(".bag-link").forEach((link) => {
      const badge = link.querySelector("span");
      if (badge) badge.textContent = String(count);
      link.setAttribute("aria-label", `${label}: ${count}`);
    });
  };

  const updateBagCountValue = (count, label) => {
    document.querySelectorAll(".bag-link").forEach((link) => {
      const badge = link.querySelector("span");
      if (badge) badge.textContent = String(count);
      link.setAttribute("aria-label", `${label}: ${count}`);
    });
  };

  const setLoading = (root, loading) => {
    if (!root) return;
    const panel = root.querySelector("[data-cart-drawer-panel]");
    const indicator = root.querySelector("[data-cart-drawer-loading]");
    panel?.setAttribute("aria-busy", loading ? "true" : "false");
    if (indicator) indicator.hidden = !loading;
    const checkout = root.querySelector("[data-cart-drawer-checkout]");
    if (loading && checkout) {
      checkout.disabled = true;
      checkout.setAttribute("aria-disabled", "true");
    }
  };

  const show = (focusPanel = false) => {
    const root = drawer();
    if (!root) return;
    root.hidden = false;
    root.setAttribute("aria-hidden", "false");
    document.body.classList.add("is-cart-drawer-open");
    window.requestAnimationFrame(() => root.classList.add("is-open"));
    if (focusPanel) window.requestAnimationFrame(() => root.querySelector("[data-cart-drawer-close]")?.focus());
  };

  const close = () => {
    const root = drawer();
    if (!root || root.hidden) return;
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    document.body.classList.remove("is-cart-drawer-open");
    window.setTimeout(() => {
      if (!root.classList.contains("is-open")) root.hidden = true;
    }, 260);
    if (returnFocus?.isConnected) returnFocus.focus();
    returnFocus = null;
  };

  const refresh = async () => {
    let current = drawer();
    if (!current) return false;
    refreshController?.abort();
    refreshController = new AbortController();
    setLoading(current, true);
    current.querySelector("[data-cart-drawer-error]")?.setAttribute("hidden", "");
    try {
      const response = await fetch(`${cartPath()}?section_id=dorimm-cart-drawer`, {
        headers: { Accept: "text/html" },
        credentials: "same-origin",
        cache: "no-store",
        signal: refreshController.signal,
      });
      if (!response.ok) throw new Error(`Cart section request failed: ${response.status}`);
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, "text/html");
      const fresh = parsed.querySelector(drawerSelector);
      if (!fresh) throw new Error("Cart drawer section missing");
      fresh.hidden = false;
      fresh.setAttribute("aria-hidden", "false");
      current.replaceWith(fresh);
      updateBagCount(fresh);
      fresh.dispatchEvent(new CustomEvent("shopify:section:load", { bubbles: true }));
      show(true);
      return true;
    } catch (error) {
      if (error?.name === "AbortError") return false;
      current = drawer();
      setLoading(current, false);
      const errorBox = current?.querySelector("[data-cart-drawer-error]");
      if (errorBox) errorBox.hidden = false;
      return false;
    }
  };

  const open = (trigger) => {
    if (!returnFocus && trigger instanceof HTMLElement) returnFocus = trigger;
    show();
    refresh();
  };

  document.addEventListener("click", (event) => {
    const opener = event.target.closest?.("[data-cart-drawer-open]");
    if (opener && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      open(opener);
      return;
    }
    if (event.target.closest?.("[data-cart-drawer-close]")) close();
  });

  document.addEventListener("keydown", (event) => {
    const root = drawer();
    if (!root || root.hidden) return;
    if (event.key === "Escape") {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== "Tab") return;
    const nodes = focusable(root);
    if (!nodes.length) {
      event.preventDefault();
      root.querySelector("[data-cart-drawer-panel]")?.focus();
      return;
    }
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener("dorimm:cart-added", (event) => {
    const trigger = document.querySelector("[data-product-atc]");
    if (!returnFocus && trigger) returnFocus = trigger;
    if (event.detail?.cart) updateBagCountValue(event.detail.cart.item_count || 0, drawer()?.dataset.cartLabel || "Cart");
    show();
    refresh();
  });

  if (drawer()) updateBagCount(drawer());
})();
